const apiOrdersURL = import.meta.env.VITE_ORDERS_API_URL;
const apiMerchantURL = import.meta.env.VITE_MERCHANT_API_URL;
const apiCustomerURL = import.meta.env.VITE_CUSTOMER_API_URL;
const apiOpenDeliveryURL = import.meta.env.VITE_OPENDELIVERY_API_URL;

const isFeatureFlagEnabled = (value: string | undefined): boolean => value === "true";

const cartSyncEnabled = isFeatureFlagEnabled(import.meta.env.VITE_CART_SYNC_ENABLED);

const sameCityCheckEnabled = isFeatureFlagEnabled(import.meta.env.VITE_DELIVERY_SAME_CITY_CHECK_ENABLED);

const birthdayEnabled = isFeatureFlagEnabled(import.meta.env.VITE_BIRTHDAY_ENABLED);

export {
  apiCustomerURL,
  apiMerchantURL,
  apiOpenDeliveryURL,
  apiOrdersURL,
  birthdayEnabled,
  cartSyncEnabled,
  isFeatureFlagEnabled,
  sameCityCheckEnabled,
};
